import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { SharedByWorkspaceFragmentDoc } from '../../../../../../../../lyearn-connect/views/LyearnConnectDetails/graphql/fragments/generated/sharedByWorkspace';
export type SingleSelectTagWithoutOptionsFragment = { id: string, name: string, description?: string | null, availableOn: Array<Types.TagAvailableOnEnum>, type: Types.TagTypeEnum, subWorkspaces?: Array<string> | null, category?: Types.TagCategoryEnum | null, source?: string | null, subType?: Types.TagSubTypeEnum | null, settings: { availableInLibrary: boolean, requiredTag: boolean, iconSettings: { type: Types.IconTypeEnum, value: string } }, createdBy?: { id: string, name?: string | null } | null, sharedByWorkspace?: { workspaceId: string, workspaceName: string, workspaceLogo?: string | null, uri: string, icon?: string | null } | null };


export type SingleSelectTagWithoutOptionsFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const SingleSelectTagWithoutOptionsFragmentDoc = /*#__PURE__*/ gql`
    fragment SingleSelectTagWithoutOptions on SingleSelectTagType {
  id
  name
  description
  availableOn
  type
  settings {
    iconSettings {
      type
      value
    }
    availableInLibrary
    requiredTag
  }
  createdBy {
    id
    name
  }
  subWorkspaces
  sharedByWorkspace {
    ...SharedByWorkspace
  }
  category
  source
  subType
}
    `;